<template>
  <v-dialog v-model="dialog" scrollable max-width="500px">
    <v-card>
      <v-card-title v-if="type=='CLUBS'">Nieuwe vereniging</v-card-title>
      <v-card-title v-else>Nieuw Restaurant</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div class="mt-5" v-if="hinttext" v-text="hinttext"></div>
        <v-form v-model="valid">
          
          <v-text-field
            ref="name"
            v-model="name"
            :rules="[$config.rules.required, $config.rules.min2]"
            label="Naam" outlined class="mt-5"
            required
          ></v-text-field>
          <!--v-text-field
            ref="city"
            v-model="city"
            :rules="[$config.rules.required]"
            label="Plaats of gemeente"
            required
          ></v-text-field>
          <v-text-field
            ref="website"
            v-model="website"
            :rules="[$config.rules.required, $config.rules.url]"
            label="Website"
            required
          ></v-text-field>
          <v-textarea
            ref="description"
            v-model="description"
            label="Beschrijving of motivatie(optioneel)"
          ></v-textarea-->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions
        ><v-btn @click="close" text>Annuleren</v-btn><v-spacer></v-spacer
        ><v-btn @click="save()" color="primary">Aanmelden<v-icon right>send</v-icon></v-btn></v-card-actions
      >
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["value","type", "hint"],
  data: () => ({
    name: null,
    website: null,
    city: null,
    valid: true,
    description:null
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    form() {
      let type = []
      if (this.type == 'CLUBS') type = ['club']
      return {
        name: this.name,
        city: this.$store.state.config.address ? this.$store.state.config.address.city : this.city,
        website: this.website,
        description: this.description,
        test: true,
        type: type,
        "|CONSUMERS": [
          {
            _id: this.$store.state.user._id,
          },
        ],
        "|OWNERS": [
          {
            _id: this.$store.state.user._id,
          },
        ],
         "#RELATIONS": [
          {
            _id: "organisation/bestelinfo", //test
          },
        ],
      };
    },
    hinttext() {
      if (this.hint) return this.hint
      if (this.type=='CLUBS') return "Staat je eigen of favoriete vereniging er niet bij? Vul hier de gegevens in dan kunnen we contact met ze opnemen zodat ook zij kunnen meedoen aan ons lokale iniitiatief en de clubkas kunnen spekken bij elke bestelling."
      return "Staat je favoriete Restaurant er niet bij? Vul hier de gegevens in dan kunnen we contact met ze opnemen zodat ook zij kunnen profiteren van on goedkopere en lokaal bestelplatform."
    }
  },

  methods: {
    close() {
      this.dialog = false;
    },
    async save() {
      if (!this.valid) return false
      let response = await this.$http.post("/api/host/" + this.type + "/hub/accounts", this.form);
      this.$emit('success', response.data)
      this.dialog = false;
    },
  },
};
</script>